import colors from 'theme/colors';
import { StationIconProps } from './types';

export const ZoneStart = ({ background = colors.coral[700], color = colors.silverGrey[50], ...rest }: StationIconProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
                fill={background}
            />
            <path
                d="M10 9.31236C10.8013 8.47117 11.8787 8 13.0007 8C14.1228 8 15.2001 8.47117 16.0015 9.31236C16.8028 10.1536 17.8801 10.6247 19.0022 10.6247C20.1242 10.6247 21.2016 10.1536 22.0029 9.31236V17.5761C21.2016 18.4173 20.1242 18.8885 19.0022 18.8885C17.8801 18.8885 16.8028 18.4173 16.0015 17.5761C15.2001 16.7349 14.1228 16.2638 13.0007 16.2638C11.8787 16.2638 10.8013 16.7349 10 17.5761V9.31236Z"
                fill={color}
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10 23.9996V17.5723" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
